/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import Frame from '../../../../../../../../../../shared/components/Frame';
import Pdf from '../../../../../../../../../../shared/components/Pdf';
import Wrapper from '../../../../../../../../../../shared/components/Wrapper';
import { convertToReal } from '../../../../../../../../../../utils/values';
import Text from '../../../Text';
import UnifiedReportOfFiducia from '../../../UnifiedReportOfFiducia';
import { IUnifiedReportPdf } from './interface';

class UnifiedReportPdf extends React.Component<IUnifiedReportPdf> {
  gridArea = `
    " clients fiducia"
    " total total "
    " footer footer"
  `;

  render() {
    return (
      <Pdf.Page>
        <Pdf.Header>
          <Pdf.Title>Relatório Unificado</Pdf.Title>
        </Pdf.Header>
        <Frame.Default isActive={this.props.data.isActive}>
          <Wrapper.Default isActive width="740px">
            <UnifiedReportOfFiducia />
            <Text.MainLabel>
              {`Saldo Unificado: ${convertToReal(
                this.props.data.fiducia.saldo_final +
                  this.props.data.terceiros.saldo_final
              )}`}
            </Text.MainLabel>
            <Wrapper.Default
              isActive
              gridArea="footer"
              flexDirection="row"
              justifyContent="space-between">
              <Wrapper.Default isActive flexDirection="row" />
            </Wrapper.Default>
          </Wrapper.Default>
        </Frame.Default>
      </Pdf.Page>
    );
  }
}

export default UnifiedReportPdf;
